import React from "react";
import { FieldLabel } from "./FieldLabel";

interface IWithLabelProps {
  children: React.ReactNode;
  label: string;
  labelId?: string;
  externalLabel?: boolean;
}
export const WithLabel: React.FC<IWithLabelProps> = ({
  children,
  label,
  labelId,
  externalLabel,
}) => {
  return externalLabel ? (
    <FieldLabel label={label} labelId={labelId}>
      {children}
    </FieldLabel>
  ) : (
    <>{children}</>
  );
};
